import { render, staticRenderFns } from "./DocumentList.vue?vue&type=template&id=c74b14be&scoped=true&"
import script from "./DocumentList.vue?vue&type=script&lang=ts&"
export * from "./DocumentList.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentList.vue?vue&type=style&index=0&id=c74b14be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74b14be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
